/**
 * PMTiles de zonificación urbana — Provincia de Córdoba (IDECOR 406).
 * El mapa arma la URL en S3; no consume map_layers desde API.
 *
 * Nota: ids de source/layer y claves S3 conservan el sufijo histórico `_ocupacion`
 * porque coinciden con los tiles publicados en el bucket.
 */

const TILES_BUCKET_HOST = 'https://s3.us-east-1.amazonaws.com/argenlot.lots';

export function pmtilesOriginalUrl(s3Key) {
  const key = s3Key.replace(/^\//, '');
  return `pmtiles://${TILES_BUCKET_HOST}/${key}`;
}

export const ZONIFICACION_URBANA_PMTILES = {
  sourceId: 'ocupacion-suelo-provincial',
  fillLayerId: 'ocupacion-suelo-provincial-fill',
  strokeLayerId: 'ocupacion-suelo-provincial-stroke',
  s3Key: 'tiles/cordoba/normativas_urbanas/cordoba_normativas_urbanas_ocupacion_v1.pmtiles',
  sourceLayer: 'normativas_urbanas_ocupacion',
  minZoom: 6,
  maxZoom: 20,
  fillOpacity: 0.28,
};

ZONIFICACION_URBANA_PMTILES.pmtilesUrl = pmtilesOriginalUrl(ZONIFICACION_URBANA_PMTILES.s3Key);
